import { MoneyConnectClientAPI } from "./axios-service-creator";

export const PerpBondAPI = {
  fetchPerpBondList: () => MoneyConnectClientAPI.get("/subscription/pre-subscription-test/securities-complex"),
  getPerpBondDetail: (payload) =>
    MoneyConnectClientAPI.post("/subscription/pre-subscription-test/securities-complex/detial", payload),
};
